import React from "react";

import Button from "@mui/material/Button";

/**
 * Dumb renderer for the "Download PDF" button.
 * Visibility rules are derived in the container.
 */

const DownloadPdfButton = ({ visible, label, onDownloadPdf }) => {
  if (!visible) return null;

  return (
    <Button
      data-cy="download-pdf"
      color="primary"
      variant="contained"
      style={{
        marginTop: 15,
        position: "relative",
        left: "50%",
        transform: "translateX(-50%)",
      }}
      onClick={onDownloadPdf}
    >
      {label}
    </Button>
  );
};

export default DownloadPdfButton;
